import { Spinner } from "react-bootstrap";
import { AANavDropdown } from "@bagel-web/components";
import { WhoAmI } from "types/app";

const SwitchOrganization = ({
  whoami,
  disabled = false,
  onSwitchOrganization,
}: {
  whoami: WhoAmI;
  disabled?: boolean;
  onSwitchOrganization: (id: string) => void;
}) => {
  if (disabled) {
    return (
      <>
        <span>Organization</span>
        <Spinner className="ms-2" size="sm" />
      </>
    );
  }

  if (whoami.organizations.length <= 1) {
    return <>{whoami.organization.name}</>;
  }

  return (
    <AANavDropdown
      title={whoami.organization.name}
      disabled={disabled}
      align="end"
      placement="auto"
    >
      <AANavDropdown.Header>Organizations</AANavDropdown.Header>
      {whoami.organizations
        .toSorted((a, b) => a.name.localeCompare(b.name))
        .map((org) => {
          return (
            <AANavDropdown.Item
              key={org.id}
              as="button"
              onClick={() => onSwitchOrganization(org.id)}
            >
              {org.name}
            </AANavDropdown.Item>
          );
        })}
    </AANavDropdown>
  );
};

export default SwitchOrganization;
